import React, { Component, memo } from 'react';
import { connect } from 'react-redux';

class GoogleMapControl extends Component {
    mapContainer = React.createRef();
    mapControl = null;
    markers = [];
    directionsRenderer = null;

    componentDidMount() {
        if (this.props.mapa && this.props.mapa.Llave) {
            this.initMap();
        }
    }

    componentDidUpdate(prevProps) {

        const gmErrores = document.getElementsByClassName("gm-err-container");
        if (this.props.mapa && this.props.mapa.Llave && (!gmErrores || gmErrores.length === 0)) {

            if (prevProps.mapa !== this.props.mapa && (!this.mapControl || this.props.mapa.Llave === 'no-key')) {
                this.initMap();
            }
            else {

                if (this.props.mapa.Llave && this.props.mapa.Llave !== 'no-key') {
                    if (prevProps.position !== this.props.position && this.mapControl) {

                        const center = new google.maps.LatLng(parseFloat(this.props.position.lat), parseFloat(this.props.position.lng));
                        this.mapControl.panTo(center);
                        if (this.markers && this.markers.length > 0) {

                            for (let i = 1; i < this.markers.length; i++) {
                                this.markers[i].setMap(null);
                            }

                            this.markers[0].position = center;
                            this.markers[0].title = this.props.title;

                            const content = document.createElement("div");
                            content.innerHTML = `<div><img src=${this.props.icon} /><p><b>${this.props.label}</b></p></div>`;
                            this.markers[0].content = content;
                        }
                        else {
                            if (!this.props.wayPoints || this.props.wayPoints.length <= 1) {
                                this.createMarker(this.props.position, this.props.icon, this.props.label, null);
                            }
                        }
                    }

                    if (prevProps.wayPoints !== this.props.wayPoints) {
                        this.calculateAndDisplayRoute();
                    }
                }
            }
        }
    }

    initMap = () => {
        const { zoom, center, position, label, icon } = this.props;

        if (!center)
            return null;

        for (let i = 0; i < this.markers.length; i++) {
            this.markers[i].setMap(null);
        }
        this.markers = [];
        this.mapControl = null;

        this.mapControl = new google.maps.Map(this.mapContainer.current, {
            center: center,
            zoom: zoom,
            mapId: 'mapa_control'
        });

        if (!this.props.wayPoints || this.props.wayPoints.length <= 1) {
            this.createMarker(position, icon, label, null);
        }
    }

    calculateAndDisplayRoute = () => {
        if (!this.props.wayPoints || this.props.wayPoints.length <= 1) {
            this.directionsRenderer && this.directionsRenderer.set('directions', null);
            this.directionsRenderer && this.directionsRenderer.setMap(null);
            this.directionsRenderer = null;
            if (!this.markers || this.markers.length === 0) {
                this.createMarker(this.props.position, this.props.icon, this.props.label, null);
            }
            return;
        }
        else {
            if (!this.directionsRenderer) {
                this.directionsRenderer = new google.maps.DirectionsRenderer();
                this.directionsRenderer.setMap(this.mapControl);
            }
        }

        for (let i = 0; i < this.markers.length; i++) {
            this.markers[i].setMap(null);
        }
        this.markers = [];

        const waypts = [];
        for (let i = 1; i < (this.props.wayPoints.length - 1); i++) {
            waypts.push({
                location: this.props.wayPoints[i].location,
                stopover: true
            });
        }


        const directionsService = new google.maps.DirectionsService();
        directionsService
            .route({
                origin: this.props.wayPoints[0].location,
                destination: this.props.wayPoints[this.props.wayPoints.length - 1].location,
                waypoints: waypts,
                optimizeWaypoints: true,
                travelMode: google.maps.TravelMode.DRIVING,
            })
            .then((response, status) => {
                //if (status == 'OK') {
                this.directionsRenderer && this.directionsRenderer.setDirections(response);
                //this.renderCustomDirections(response, status, this.props.wayPoints);
                //} else {
                //  console.log('Directions request failed due to ' + status);
                //  }

                //const route = response.routes[0];
                //const summaryPanel = document.getElementById("directions-panel");

                //summaryPanel.innerHTML = "";

                //// For each route, display summary information.
                //for (let i = 0; i < route.legs.length; i++) {
                //    const routeSegment = i + 1;

                //    summaryPanel.innerHTML +=
                //        "<b>Route Segment: " + routeSegment + "</b><br>";
                //    summaryPanel.innerHTML += route.legs[i].start_address + " to ";
                //    summaryPanel.innerHTML += route.legs[i].end_address + "<br>";
                //    summaryPanel.innerHTML += route.legs[i].distance.text + "<br><br>";
                //}
            })
            .catch((e) => console.log("Directions request failed due to " + e));
    }

    renderCustomDirections = (response, status, wayPoints) => {
        if (status == google.maps.DirectionsStatus.OK) {
            waypts = [];
            var bounds = new google.maps.LatLngBounds();

            startLocation = new Object();
            endLocation = new Object();

            var legs = response.routes[0].legs;

            for (i = 0; i < legs.length; i++) {
                if (i == 0) {
                    startLocation.latlng = legs[i].start_location;
                    startLocation.address = legs[i].start_address;
                    startLocation.marker = createMarker(legs[i].start_location, "start", legs[i].start_address, "green", String.fromCharCode("A".charCodeAt(0)));
                } else {

                    waypts[i] = new Object();
                    waypts[i].latlng = legs[i].start_location;
                    waypts[i].address = legs[i].start_address;
                    waypts[i].marker = createMarker(legs[i].start_location, res.data[(i - 1)].empName + " " + res.data[(i - 1)].stratingTime + " " + res.data[(i - 1)].presentStatus, legs[i].start_address, "yellow", String.fromCharCode("A".charCodeAt(0) + i));

                }
                endLocation.latlng = legs[i].end_location;
                endLocation.address = legs[i].end_address;
                var steps = legs[i].steps;
                for (j = 0; j < steps.length; j++) {
                    var nextSegment = steps[j].path;
                    for (k = 0; k < nextSegment.length; k++) {
                        bounds.extend(nextSegment[k]);
                    }
                }
            }
            endLocation.marker = createMarker(endLocation.latlng, "My Company", endLocation.address, "red", String.fromCharCode("A".charCodeAt(0) + waypts.length));
            google.maps.event.trigger(endLocation.marker, 'click');
        }
        else {
            console.log(status);
        }
    }

    createMarker = async (position, icon, label, infoHtml) => {

        if (!this.mapControl) {
            return;
        }

        const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

        const content = document.createElement("div");
        content.innerHTML = `<div><img src=${this.props.icon} /><p><b>${this.props.label}</b></p></div>`;

        const marker = new AdvancedMarkerElement({
            position: position,
            map: this.mapControl,
            content: content,
            title: label
        });

        this.markers.push(marker);

        /*if (infoHtml) {
            google.maps.event.addListener(marker, 'click', function () {
                infowindow.setContent(infoHtml);
                infowindow.open(this.mapControl, marker);
            });
        }*/

        return marker;
    }

    loadScript = (id, src) => {
        let element = document.getElementById(id);
        if (!element) {
            let tag = document.createElement('script');
            tag.async = true;
            tag.src = src;
            tag.id = id;
            document.getElementsByTagName('body')[0].appendChild(tag);
        }
    };

    removeScript = (id) => {
        let element = document.getElementById(id);
        if (element) {
            element.parentNode.removeChild(element);
        }
    };

    render() {
        return <div ref={this.mapContainer} style={{ height: '100%' }}></div>;
    }
};

const mapStateToProps = state => {
    return {
        mapa: state.parametros.mapa
    };
};

export default connect(mapStateToProps)(memo(GoogleMapControl));